module.exports = __webpack_public_path__ + "media/images/lb/442-e63e2fbb4f8bbfed0a7000aa539f4551.svg";